var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('select',{staticClass:"js-data-example-ajax",staticStyle:{"width":"300px"}})])])
}]

export { render, staticRenderFns }